import React, { useState, useRef, useEffect } from 'react';
import { Link } from '../../../env'
import Marquee from 'react-fast-marquee';
const Widgets = ({ handleClick }) => {
  const Links = [
    {
      img: `${Link}assets/CarsBrands/Lifan.png`,
    },
    {
      img: `${Link}assets/CarsBrands/Nissan.png`,
    },
    {
      img: `${Link}assets/CarsBrands/Toyota.png`,
    },
    {
      img: `${Link}assets/CarsBrands/bmw.png`,
    },
    {
      img: `${Link}assets/CarsBrands/chery.png`,
    },
    {
      img: `${Link}assets/CarsBrands/ford.png`,
    },
    {
      img: `${Link}assets/CarsBrands/hyunda.png`,
    },
    {
      img: `${Link}assets/CarsBrands/irankhodro.png`,
    },
    {
      img: `${Link}assets/CarsBrands/kia.png`,
    },
    {
      img: `${Link}assets/CarsBrands/mazda.png`,
    },
    {
      img: `${Link}assets/CarsBrands/mercedes.png`,
    },
    {
      img: `${Link}assets/CarsBrands/misbishi.png`,
    },
    {
      img: `${Link}assets/CarsBrands/parskhodro.png`,
    },
    {
      img: `${Link}assets/CarsBrands/saipa.png`,
    },
  ]
  const [flagModal, setFlagModal] = useState(false)
  const [flagSelected, setFlagSelected] = useState('us')
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setFlagModal(false)
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  const Flags = [
    {
      label: 'ir',
      img: `${Link}/assets/Flags/ir-lang.png`,
    },
    {
      label: 'ru',
      img: `${Link}/assets/Flags/ru-lang.png`,
    },
    {
      label: 'us',
      img: `${Link}/assets/Flags/us-lang.png`,
    },
    {
      label: 'ar',
      img: `${Link}/assets/Flags/em-lang.png`,
    }
  ]
  const WidgetsComponents = [
    {
      label: 'Home',
      img: `${Link}assets/Mobile/Home.png`,
    },
    {
      label: 'Onlin Chat',
      img: `${Link}assets/Mobile/chat.png`,
    },

    {
      label: 'Downloads',
      img: `${Link}assets/Mobile/Downloads.png`,
    },
    {
      label: 'Contacts us',
      img: `${Link}assets/Mobile/contactus.png`,
    },
    {
      label: 'Tutorials',
      img: `${Link}assets/Mobile/Tutorial.png`,
    },
    {
      label: 'Buy',
      img: `${Link}assets/Mobile/BitCoin.png`,
    },
  ]
  const HandleHome = (data) => {
    handleClick(data)
  }
  const HandleFlag = () => {
    setFlagModal(!flagModal)
  }
  const HandleFlagSelection = (data) => {
    setFlagSelected(data)
  }
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  return (
    <div className='w-full min-h-screen bg-[#283747] overflow-y-hidden'>
      <div className='w-full px-5'>
        <div className='w-full py-5'>
          <div className='w-full h-[50px] rounded-xl bg-[rgba(44,83,121,0.6)] border-[1px] border-[rgba(255,255,255,0.5)] flex justify-between items-center'>
            <div className='w-full flex items-center h-full px-5'>
              <span className='text-white text-sm poppins-regular'>IRSystem</span>
              <span className='text-[#f4d03f] text-sm poppins-regular'>Tuning</span>
            </div>
            <div className='w-full h-full flex items-center justify-end px-5 relative'>
              {
                Flags.map((item, index) => {
                  return item.label == flagSelected ? <img key={index} onClick={HandleFlag} src={item.img} className='w-[30px]' /> : ''
                })
              }

              {
                false && flagModal && <div className='absolute top-[52px] rounded-md right-[10px] bg-[rgba(255,255,255,0.6)]'>
                  <ul ref={wrapperRef} className='w-full h-full'>
                    {
                      Flags.map((item, index) => {
                        return (<>
                          <li className={`w-full flex justify-center p-2`}>
                            <img key={index} onClick={(e) => HandleFlagSelection(item.label)} src={item.img} className='w-[30px] h-[30px]' />
                          </li>
                        </>)
                      })
                    }
                  </ul>
                </div>
              }

            </div>
          </div>
        </div>
        <div className='w-full flex justify-start translate-y-[25px]'>
          <span className='text-white text-sm mx-1 poppins-regular'>Login</span>
          <span className='text-white text-sm mx-0 poppins-regular'>{`/`}</span>
          <span className='text-white text-sm mx-1 poppins-regular'>Register</span>
        </div>
        <div className='w-full grid grid-cols-2 gap-5 py-10'>

          {
            WidgetsComponents.map((item, index) => {
              return (<>
                <div key={index} onClick={(e) => HandleHome(item.label)} className='w-full Box-Shadow border-[1px] border-[rgba(255,255,255,0.5)] bg-[rgba(44,83,121,0.6)] h-[120px] flex justify-center items-center border-[#ecf0f1] rounded-xl'>
                  <div className='w-full'>
                    <div className='w-full flex justify-center'>
                      <img src={item.img} className='w-[30px]' />
                    </div>
                    <div className='w-full text-center text-white mt-5 poppins-regular text-sm'>
                      {item.label}
                    </div>
                  </div>
                </div>
              </>)
            })
          }

        </div>
      </div>
      <div className='w-full -translate-y-[20px]'>
        <div className='w-full px-5'>
          <div className='w-full mt-3 h-[60px] rounded-lg flex items-center bg-[rgba(44,83,121,0.4)] border-[1px] border-[rgba(255,255,255,0.5)]'>
            <Marquee speed={30} gradient={false}>
              <div className='w-full flex items-center space-x-[40px]'>
                {
                  Links.map((item, index) => {
                    return (<>
                      <img src={item.img} className='w-[40px] h-[40px]' />
                    </>)
                  })
                }
                <div></div>
              </div>
            </Marquee>
          </div>
          <div className='w-full text-center mt-[40px]'>
            <div className='text-[12px] text-[#99a3a4]'>irsystem Co.2024</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Widgets;
